<div class="or-d-flex or-justify-content-between or-align-items-center or-mt-8-px">
  <div class="or-head-lg">{{ game().gameName }}</div>

  <div class="or-align-items-center or-d-flex">
    <div class="or-mr-8-px">
      <ng-content></ng-content>
    </div>
    @if (adminAccess()) {
      <or-icon name="eye" size="s" (click)="showAdminDetails()" class="or-mr-8-px" />
    }
    <or-icon name="copy-link" size="s" [shareGame]="game()" boxed class="or-color-white or-bg-main-1" />
  </div>
</div>

<div class="or-d-flex or-align-items-center or-mt-12-px">
  <or-icon name="clock" size="xxs" circle class="or-mr-8-px" />

  <div>
    <div class="or-head-xs or-color-secondary-2">Data</div>
    <div class="or-text-md">{{ game().formattedDate }}</div>
  </div>
</div>

<div class="or-d-flex or-align-items-center or-mt-12-px">
  <or-icon name="location" size="xxs" circle class="or-mr-8-px" />

  <div>
    <div class="or-head-xs or-color-secondary-2">Adres</div>
    <div class="or-text-md">
      {{ game().location.address }}, {{ game().location.city }}
      @if (showNavigateLink()) {
        <span
          class="or-text-sm or-color-primary or-text-decoration-underline or-cursor-pointer"
          [navigate]="game().location.coordinates"
          >Nawiguj</span
        >
      }
    </div>
  </div>
</div>

<div class="or-d-flex or-justify-content-space-around">
  <div>
    <div class="or-d-flex or-align-items-center or-mt-12-px">
      <or-icon name="profile" size="xxs" circle class="or-mr-8-px" />

      <div>
        <div class="or-head-xs or-color-secondary-2">Gracze</div>
        <div class="or-text-md">{{ game().occupiedSlots }}/{{ game().totalSlots }}</div>
      </div>
    </div>

    @if (showGameTypeDetails()) {
      <div class="or-d-flex or-align-items-center or-mt-12-px">
        <or-icon name="games" size="xxs" circle class="or-mr-8-px" />

        <div>
          <div class="or-head-xs or-color-secondary-2">Typ gierki</div>
          <div class="or-text-md">{{ gameType() }}</div>
        </div>
      </div>
    }

    <div class="or-d-flex or-align-items-center or-mt-12-px">
      <or-icon name="price" size="xxs" circle class="or-mr-8-px" />

      <div>
        <div class="or-head-xs or-color-secondary-2">Cena</div>
        @if (game().priceAmount) {
          <div class="or-text-md">{{ game().priceAmount }} zł</div>
        } @else {
          <div class="or-text-md">Darmowa</div>
        }
      </div>
    </div>

    @if (game().priceAmount) {
      <div class="or-d-flex or-align-items-center or-mt-12-px">
        <ng-container *ngTemplateOutlet="locationType"></ng-container>
      </div>
    }
  </div>
  <div class="or-ml-28-px">
    <div class="or-d-flex or-align-items-center or-mt-12-px">
      <or-icon name="level" size="xxs" circle class="or-mr-8-px" />

      <div>
        <div class="or-head-xs or-color-secondary-2">Poziom</div>
        <div class="or-text-md">{{ game().level }}</div>
      </div>
    </div>

    @if (showGameTypeDetails()) {
      <div class="or-d-flex or-align-items-center or-mt-12-px">
        <or-icon name="globe" size="xxs" circle class="or-mr-8-px" />

        <div>
          <div class="or-head-xs or-color-secondary-2">Widoczność na mapie</div>
          <div class="or-text-md">{{ gameVisibilityLabel() }}</div>
        </div>
      </div>
    }
    @if (game().priceAmount) {
      <div class="or-d-flex or-align-items-center or-mt-12-px">
        <or-icon name="amount-2" size="xxs" circle class="or-mr-8-px" />

        <div>
          <div class="or-head-xs or-color-secondary-2">Płatność</div>
          <div class="or-text-md">{{ game().paymentType?.join(' / ') }}</div>
        </div>
      </div>
    } @else {
      <div class="or-d-flex or-align-items-center or-mt-12-px">
        <ng-container *ngTemplateOutlet="locationType"></ng-container>
      </div>
    }
  </div>
</div>

@if (showGoToChat()) {
  <div class="or-d-flex or-mt-16-px">
    <div
      (click)="goToChat($event, game().gameId)"
      class="border-shade border-radius-4 or-p-8-px or-mr-8-px or-w-100-pc or-bg-white or-d-flex">
      <or-icon name="messages" size="m" class="or-mr-8-px" />
      <div class="or-text-md or-my-4-px">Chat gierki</div>
    </div>
  </div>
}

@if (game().description) {
  <div class="or-d-flex or-align-items-center or-mt-16-px">
    <div>
      <div class="or-head-xs or-color-secondary-2">Szczegóły gierki</div>
      <div
        #descriptionEl
        class="or-text-md white-space-pre-wrap"
        [class.description-clamped]="!isDescriptionExpanded()">
        {{ game().description }}
      </div>
      @if (isDescriptionOverflowing() || isDescriptionExpanded()) {
        <div (click)="toggleDescription()" class="or-text-md or-color-primary or-cursor-pointer or-mt-4-px">
          {{ isDescriptionExpanded() ? 'Zwiń' : 'Pokaż więcej' }}
        </div>
      }
    </div>
  </div>
}

@if (showHostInfo()) {
  <div class="or-d-flex or-align-items-center or-mt-24-px">
    <lib-or-avatar
      [avatarUrl]="game().host?.thumbnail"
      [initials]="game().host?.displayName"
      [redirectToUserProfile]="game().host?.hostId"
      [avatarSize]="'sm'"></lib-or-avatar>

    <div class="or-d-flex or-justify-content-between or-w-100-pc">
      <div [redirectToUserProfile]="game().host?.hostId">
        <div>
          <div class="or-d-flex or-align-items-center">
            <div class="or-head-sm">{{ game().host?.displayName }}</div>
            @if (hostRating()) {
              <or-icon name="star" size="xs" class="or-ml-8-px or-mr-4-px or-mb-2-px or-color-yellow" />
              <div class="or-head-xs">{{ hostRating() }}</div>
            }
          </div>

          <div class="or-text-sm or-color-secondary-2">Aktywny {{ calculatelastActive(game().host?.lastActive) }}</div>
        </div>
      </div>

      @if (!isMyGame()) {
        <div class="or-d-flex or-align-items-center">
          <or-icon
            name="contact"
            size="s"
            boxed
            class="or-color-white or-bg-main-1"
            (click)="sendMessage(game().host?.hostId, game().host?.displayName, $event)" />

          @if (showPhoneNumber()) {
            <div
              [copyToClipboard]="game().gameContactPhone"
              class="button-primary-style or-align-items-center or-d-flex or-head-md or-justify-content-between or-px-8-px or-ml-4-px or-h-32-px or-cursor-pointer"
              [ngClass]="{ 'disabled-button': !game().gameContactPhone }">
              <or-icon name="phone" size="xs" class="or-mr-4-px or-color-white" />

              <span
                class="or-color-white or-head-xs text-no-wrap"
                [ngClass]="{ 'disabled-button': !game().gameContactPhone }"
                >Skopiuj numer</span
              >
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<ng-template #locationType>
  <or-icon name="field-type-2" size="xxs" circle class="or-mr-8-px" />

  <div>
    <div class="or-head-xs or-color-secondary-2">Typ boiska</div>
    <div class="or-text-md">{{ locationTypeMapper[game().locationType].name }}</div>
  </div>
</ng-template>
